<ng-container *transloco="let t">
  @if (displayRequestBilling()) {
    <pxw-input-checkbox
      name="isVatConditionRequired"
      [label]="t('endOrder.billingLabel')"
      [legend]="t('endOrder.billingRequestLegend')"
      [helper]="t('endOrder.billingRequestHelper')"
      [(ngModel)]="requestBilling"
    />
  }

  @if (requestBilling()) {
    <pxw-select-box
      name="vatCondition"
      [label]="t('endOrder.billingVatCondition')"
      [options]="vatConditionOptions()"
      labelKey="name"
      valueKey="id"
      [(ngModel)]="vatCondition"
      [required]="true"
    />
    <pxw-input-text
      name="billingName"
      [label]="t('endOrder.billingName')"
      [(ngModel)]="billingName"
      [required]="isVatConditionBusiness()"
      [displayErrors]="isFormSubmitted()"
    />

    <pxw-input-text
      name="billingDocument"
      [label]="t('endOrder.billingDocument')"
      [(ngModel)]="documentNumber"
      [required]="isVatConditionBusiness()"
      [pattern]="documentPattern() || ''"
      [custom]="documentValidator()"
      [displayErrors]="isFormSubmitted()"
      [messages]="{
        invalidCuit: t('validation.invalidMask'),
        pattern: t('validation.invalidMask'),
      }"
    >
      <div class="addon-prepend document-type-addon">
        <pxw-select-box
          style="width: 100px; margin: 0"
          name="documentType"
          [options]="documentTypeOptions()"
          labelKey="name"
          valueKey="id"
          [(ngModel)]="documentType"
          [required]="true"
          [disabled]="documentTypeOptions().length === 1"
        />
      </div>
    </pxw-input-text>

    <pxw-input-text
      name="billingAddress"
      [label]="
        isVatConditionBusiness()
          ? t('endOrder.billingBusinessAddress')
          : t('endOrder.billingAddress')
      "
      [(ngModel)]="billingAddress"
      [required]="isVatConditionBusiness()"
      [displayErrors]="isFormSubmitted()"
    />
  }
</ng-container>
